export default {
    title: 'Note templates',
    subtitle: 'View and edit your note templates',
    add: 'Create new template',
    name: 'Template name',
    searchPlaceholder: 'Search a template...',
    empty: {
        title: 'No note templates yet',
        subtitle: 'Create a template to write notes faster.',
        noMatch: 'No templates found'
    },
    edit: {
        pageTitle: 'Edit notes',
        title: 'Diet plan notes',
        subtitle: 'Type your notes to print with your diet plan.',
        createNew: 'Create new template',
    }
}